import './css/Footer.css'

const Footer = (props) => {
    return (
        <footer>
            <div id="copyright">
                Copyright &copy;2022 <b>ssu-commerce</b> All rights reserved.<br/>
                We welcome contributors. Please contribute to the project!
            </div>
        </footer>
    )
}
export default Footer;